var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCreditCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.00195312C4.49 0.00195312 0 4.49195 0 10.002C0 15.512 4.49 20.002 10 20.002C15.51 20.002 20 15.512 20 10.002C20 4.49195 15.51 0.00195312 10 0.00195312ZM14 10.752H10.75V14.002C10.75 14.412 10.41 14.752 10 14.752C9.59 14.752 9.25 14.412 9.25 14.002V10.752H6C5.59 10.752 5.25 10.412 5.25 10.002C5.25 9.59195 5.59 9.25195 6 9.25195H9.25V6.00195C9.25 5.59195 9.59 5.25195 10 5.25195C10.41 5.25195 10.75 5.59195 10.75 6.00195V9.25195H14C14.41 9.25195 14.75 9.59195 14.75 10.002C14.75 10.412 14.41 10.752 14 10.752Z",
    fill: "#2D355A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCreditCard);
export default __webpack_public_path__ + "static/media/addCreditCard.39fea6ca823fc568e789edb6e59f6175.svg";
export { ForwardRef as ReactComponent };